module.exports = __webpack_public_path__ + "static/media/locate-charging-stations.edeeb553.svg";